import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationCartActionIcons = {
  CONTINUE: 'pointer-right',
  EXTERNAL: 'link',
} as const

export type ConversationCartActionIconEnum = Enum<
  typeof ConversationCartActionIcons
>
